import { v4 as uuid } from "uuid";
import { z } from "zod";
import { LocalContentType } from "../../entities/packageLocalContent";
export const contractorPackageLocalContentTargetLineItemSchema = z.object({
    contractorPackageId: z.string(),
    created: z.date(),
    districtTargetValue: z.number(),
    id: z.string(),
    regionalTargetValue: z.number(),
    targetType: z.enum(LocalContentType),
    targetValue: z.number()
});
export const createDefaultContractorPackageLocalContentTarget = (contractorPackageId, localContentType, value, regionalValue = 0, districtValue = 0) => {
    return {
        contractorPackageId: contractorPackageId,
        created: new Date(),
        districtTargetValue: districtValue,
        id: uuid(),
        regionalTargetValue: regionalValue,
        targetType: localContentType,
        targetValue: value
    };
};
